import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
            <a href="#categories">漫画分类</a>
          </h2>
          <p className="text-foreground-500 text-sm">探索你喜欢的漫画类型</p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3 md:gap-4">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="flex flex-col items-center gap-3 p-4 md:p-5 rounded-xl bg-background-50 hover:bg-background-200/70 transition-all duration-300 group cursor-pointer border border-background-200/70"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-100 group-hover:bg-accent-200 transition-colors">
                <i className={`${category.icon} text-accent-600 text-xl md:text-2xl`}></i>
              </div>
              <span className="text-foreground-700 text-xs md:text-sm font-medium whitespace-nowrap group-hover:text-primary-500 transition-colors">
                {category.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}